import { Pagination } from "src/app/services/response-models/pagination.response.model";

export class LoadProjectWallPostsPagination {
    public static readonly type = "[Project Wall] Load project wall pagination";

    constructor(public payload: Pagination) {}
}
